// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { StyledButton } from "@insite/mobius/Clickable";
import DataTablePresentationPropsDefault from "@insite/mobius/DataTable/presentationProps";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { DataTableCssOverrides } from "@tps/MobiusOverrides/DataTable/DataTable";
import { xBaseTheme } from "@tps/XDL/types";
import { color, xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...DataTablePresentationPropsDefault,
        mergeCss: true,
        cssOverrides: {
            header: css`
                background: ${color("common.ui5")};
                height: initial;
                border: 1px solid ${color("common.ui4")};
                padding: 5px 9px;
            `,
            head: css`
                background: ${color("common.ui5")};
            `,
            cell: css`
                border: 1px solid ${color("common.ui4")};
                padding: 5px 9px;
                height: initial;
                vertical-align: initial;
                ${xScreen("lte", 767)} {
                    padding: 9px;
                }

            `,
            row: css`
                background: ${color("common.white")};
            `,
            evenRow: css`
                background: ${color("common.ui2")};
            `,
        } as DataTableCssOverrides,
        headerTypographyProps: {
            mergeCss: true,
            size: 12,
            weight: 700,
            color: "common.white",
            css: css`
                letter-spacing: 0;
                line-height: 20px;
            `,
        },
        cellTypographyProps: {
            mergeCss: true,
            size: 14,
            weight: "normal",
            css: css`
                letter-spacing: 0;
                line-height: 22px;
            `,
        },
        sortClickableProps: {
            css: css`
                width: 100%;
                height: 100%;
            `,
        },
        sortIconProps: {
            size: 12,
            color: "common.white",
            css: css`
                margin-left: 8px;
            `,
        },
        css: css`
            td[class^="DataTableCellBase"] {
                & > ${TypographyStyle}:empty:after {
                    content: "- -";
                }
                & > ${StyledButton} > ${TypographyStyle} {
                    font-size: 14px;
                }
            }
        `,
    },
} as xBaseTheme["dataTable"];
